import React, { useEffect, useState } from "react";
import ctl from "@netlify/classnames-template-literals";
import { Container } from "components/container";
import { Text } from "components/text";

const Cookies = () => {
  const [notifyCookies, setNotifyCookies] = useState(false);

  const setCookie = () => {
    document.cookie = `_pk_CK_SET = 100`;
    setNotifyCookies(true);
  };

  useEffect(() => {
    localStorage.clear(); //clear cookie settings previously stored in local storage
    const getCookieSettings = document.cookie
      .split("; ")
      .find(y => y.startsWith("_pk_CK_SET"))
      ?.split("=")[1];
    if (getCookieSettings === "100") {
      setNotifyCookies(true);
    }
  }, [setNotifyCookies]);

  return (
    <>
      {notifyCookies ? (
        ""
      ) : (
        <div className={cookie}>
          <Container>
            <div className={cookieInner}>
              <Text
                value="We use cookies on our website to improve your user experience. By using our website, you consent to our use of cookies"
                variant="p"
                className={cookieText}
              />
              <button onClick={() => setCookie()} className={cookieBtn}>
                ok
              </button>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

const cookie = ctl(`
  md:w-full 
  fixed 
  bottom-0 
  z-[9999] 
  bg-primary py-3
`);

const cookieInner = ctl(`
  flex 
  flex-row
  max-[425px]:flex-col
  gap-10 
  items-center 
  justify-between
`);

const cookieText = ctl(`
  max-[425px]:text-center
`);

const cookieBtn = ctl(`
  bg-secondary
  text-white
  px-3
  py-1.5
  rounded-full
  max-[425px]:w-full
`);

export { Cookies };
